import {
  Checkbox,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { t } from "i18next";
import React from "react";
import { useSelector } from "react-redux";

const FormAssoCaaf = ({
  termini,
  setTermini,
  formData,
  selectList,
  privacy,
  setPrivacy,
  handleChangeRadioAuto,
  consenso,
  setConsenso,
  autoDati,
}) => {
  const appConfig = useSelector((state) => state.app.appConfig);

  return (
    <div className="w-full flex flex-col justify-start mt-5">
      <FormControlLabel
        className="pt-3"
        required
        label={
          formData.role === selectList.admin ? (
            <>
              {t("ReadAndAccept")}{" "}
              <a
                href={
                  appConfig?.customPolicyAndTerms?.terms
                    ? appConfig?.customPolicyAndTerms?.terms
                    : `${window.location.origin}/${t("terms-and-conditions")}`
                }
                target="_blank"
                rel="noreferrer"
              >
                {t("TermsAndConditions")}
              </a>
            </>
          ) : (
            <>
              Il sottoscritto conferisce incarico per l'anno 2025 e per quello
              successivo alla Società/Sede periferica CAF ASSOCAAF SPA, per la
              prestazione di servizi di assistenza fiscale e per ogni servizio
              che verrà indicato dal richiedente durante lo svolgimento
              dell'incarico, autorizzando il CAF sin d’ora, per le finalità dei
              servizi ed incarichi richiesti, all’attività di accesso,
              consultazione e prelievo dei propri dati detenuti presso Enti
              Previdenziali/Assistenziali, Agenzia delle Entrate e Sostituti
              d’imposta
            </>
          )
        }
        control={
          <Checkbox checked={termini} onChange={() => setTermini(!termini)} />
        }
      />

      <FormControlLabel
        className="pt-3"
        required
        label={
          formData.role === selectList.admin ? (
            <>
              {t("ReadAndAccept2")}{" "}
              <a
                href={appConfig?.customPolicyAndTerms?.adminPolicy}
                target="_blank"
                rel="noreferrer"
              >
                privacy policy
              </a>
            </>
          ) : (
            <>
              <p>
                Presa visione informativa RESPONSABILITA’ AMMINISTRATIVA DI ENTI
                E PERSONE GIURIDICHE Ex D. Lgs. 231/2001 il sottoscritto
                dichiara di aver letto l’informativa con la quale Assocaaf
                comunica di essersi dotata di un “Modello di organizzazione,
                gestione e controllo redatto ai del D. Lgs. 231/2001” e di
                aderire ai principi in esso contemplati.
              </p>
              <small>
                Il predetto Modello 231 introduce il principio della
                Responsabilità amministrativa delle persone giuridiche per i
                reati commessi o tentati da soggetti che intrattengano rapporti
                con Assocaaf per il perseguimento dell’interesse o del vantaggio
                dell’Ente stesso.
              </small>
            </>
          )
        }
        control={
          <Checkbox checked={privacy} onChange={() => setPrivacy(!privacy)} />
        }
      />

      {formData.role === selectList.user && (
        <div className="mt-2">
          <FormControlLabel
            className="py-3"
            required
            label={
              <>
                Dichiaro di prestare il consenso al trattamento dei miei dati
                personali, per le finalità dell’informativa privacy dell’App.{" "}
                <br />
                Per visualizzare la{" "}
                <a
                  href={appConfig?.customPolicyAndTerms?.userPolicy}
                  target="_blank"
                  rel="noreferrer"
                >
                  privacy policy
                </a>
              </>
            }
            control={
              <Checkbox
                checked={consenso}
                onChange={() => setConsenso(!consenso)}
              />
            }
          />

          <FormLabel className="mt-3 text-sm  ">
            Dichiaro di prestare il consenso al trattamento dei miei dati
            personali per finalità promozionali e commerciali.
          </FormLabel>
          <RadioGroup row value={autoDati} onChange={handleChangeRadioAuto}>
            <FormControlLabel
              control={<Radio />}
              value={true}
              label="Autorizzo"
            />
            <FormControlLabel
              value={false}
              control={<Radio />}
              label="Non autorizzo"
            />
          </RadioGroup>
        </div>
      )}
    </div>
  );
};

export default FormAssoCaaf;
